export default "__VITE_ASSET__D635ajLS__"